import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faSearch,
  faBook,
  faUser,
  faEllipsisH,
  faTimes,
  faRss,
  faStar,
} from '@fortawesome/free-solid-svg-icons';

function itemClass(pathname, active) {
  return `app-mobile-nav-item${active ? ' app-mobile-nav-item--active' : ''}`;
}

export default function AppMobileNav() {
  const { currentUser } = useAuth();
  const { pathname } = useLocation();
  const [moreOpen, setMoreOpen] = useState(false);

  const closeMore = useCallback(() => setMoreOpen(false), []);

  useEffect(() => {
    if (!moreOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') closeMore();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [moreOpen, closeMore]);

  useEffect(() => {
    closeMore();
  }, [pathname, closeMore]);

  useEffect(() => {
    if (!moreOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [moreOpen]);

  const profileActive = currentUser
    ? pathname.startsWith('/user/') ||
      pathname === '/user-redirect' ||
      pathname === '/update-profile'
    : pathname === '/login' || pathname === '/signup';

  return (
    <>
      <nav className="app-mobile-nav" aria-label="Mobile navigation">
        <Link
          to="/"
          className={itemClass(pathname, pathname === '/')}
          aria-current={pathname === '/' ? 'page' : undefined}
        >
          <FontAwesomeIcon icon={faHome} className="app-mobile-nav-icon" />
          <span>Home</span>
        </Link>

        {currentUser ? (
          <Link
            to="/home"
            className={itemClass(pathname, pathname === '/home')}
            aria-current={pathname === '/home' ? 'page' : undefined}
          >
            <FontAwesomeIcon icon={faRss} className="app-mobile-nav-icon" />
            <span>Feed</span>
          </Link>
        ) : (
          <Link
            to="/bookstore"
            className={itemClass(
              pathname,
              pathname.startsWith('/bookstore')
            )}
            aria-current={pathname.startsWith('/bookstore') ? 'page' : undefined}
          >
            <FontAwesomeIcon icon={faBook} className="app-mobile-nav-icon" />
            <span>Store</span>
          </Link>
        )}

        {currentUser ? (
          <Link
            to="/search"
            className={itemClass(pathname, pathname === '/search')}
            aria-current={pathname === '/search' ? 'page' : undefined}
          >
            <FontAwesomeIcon icon={faSearch} className="app-mobile-nav-icon" />
            <span>Search</span>
          </Link>
        ) : (
          <Link
            to="/subscription"
            className={itemClass(pathname, pathname === '/subscription')}
            aria-current={pathname === '/subscription' ? 'page' : undefined}
          >
            <FontAwesomeIcon icon={faStar} className="app-mobile-nav-icon" />
            <span>Join</span>
          </Link>
        )}

        <Link
          to={currentUser ? '/user-redirect' : '/login'}
          className={itemClass(pathname, profileActive)}
          aria-current={profileActive ? 'page' : undefined}
        >
          <FontAwesomeIcon icon={faUser} className="app-mobile-nav-icon" />
          <span>{currentUser ? 'Profile' : 'Log in'}</span>
        </Link>

        <button
          type="button"
          className={`app-mobile-nav-item app-mobile-nav-item--btn${
            moreOpen ? ' app-mobile-nav-item--active' : ''
          }`}
          aria-expanded={moreOpen}
          aria-haspopup="true"
          aria-label="Open more menu"
          onClick={() => setMoreOpen((v) => !v)}
        >
          <FontAwesomeIcon icon={faEllipsisH} className="app-mobile-nav-icon" />
          <span>More</span>
        </button>
      </nav>

      {moreOpen && (
        <div
          className="app-mobile-more-backdrop"
          role="presentation"
          onClick={closeMore}
        >
          <div
            className="app-mobile-more-sheet"
            role="dialog"
            aria-modal="true"
            aria-label="More menu"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="app-mobile-more-header">
              <span>Menu</span>
              <button
                type="button"
                className="app-mobile-more-close"
                aria-label="Close menu"
                onClick={closeMore}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="app-mobile-more-links">
              {currentUser ? (
                <>
                  <Link to="/subscription" onClick={closeMore}>
                    Subscribe
                  </Link>
                  <Link to="/bookcase" onClick={closeMore}>
                    Bookcase
                  </Link>
                  <Link to="/advertise" onClick={closeMore}>
                    Advertise
                  </Link>
                  <Link to="/update-profile" onClick={closeMore}>
                    Edit profile
                  </Link>
                  <Link to="/dashboard" onClick={closeMore}>
                    Account
                  </Link>
                </>
              ) : (
                <>
                  <Link to="/bookstore" onClick={closeMore}>
                    Bookstore
                  </Link>
                  <Link to="/subscription" onClick={closeMore}>
                    Subscribe
                  </Link>
                  <Link to="/advertise" onClick={closeMore}>
                    Advertise
                  </Link>
                  <Link to="/signup" onClick={closeMore}>
                    Sign up
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
